export { default } from './Badge';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Badge/index.js
// module id = 575
// module chunks = 121